import { useState } from "react";
import { AuthPage } from "../../common/components/template_page/auth";
import { IStateScreen } from "./dtos";
import { ConfirmationScreen } from "./screens/confirmation";
import { InitialScreen } from "./screens/initial";
import { UpdatePasswordScreen } from "./screens/updatePassword";

export const ForgotPassword = () => {
  const [screen, setScreen] = useState<IStateScreen>({
    currentScreen: 1, who: ""
  });

  return (
    <AuthPage>
      <>
        {screen.currentScreen === 1 && (
          <InitialScreen stateScreen={screen} dispatchScreen={setScreen} />
        )}
        {screen.currentScreen === 2 && (
          <UpdatePasswordScreen stateScreen={screen} dispatchScreen={setScreen} />
        )}
        {screen.currentScreen === 3 && (
          <ConfirmationScreen />
        )}
      </>
    </AuthPage>
  )
}